import { gql } from '@apollo/client'

export default gql`
  query outstandingCount {
    projects {
      id
      outstandingAssignments {
        id
      }
    }
  }
`
